"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1414))
 * @lastsynced 2026-10-29T13:49:45.142Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Calendar = createSVGIcon(
  <path
    d="M2.571 4.285A1.714 1.714 0 0 0 .857 6v15.428a1.714 1.714 0 0 0 1.714 1.714h18.857a1.714 1.714 0 0 0 1.715-1.714V6a1.714 1.714 0 0 0-1.715-1.715H18M.857 11.143h22.286M6 .858v6.857M18 .858v6.857M6 4.285h8.571"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Calendar",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
